import { useConfig, chargeoverInvoiceUrl } from '../hooks/useConfig';

/**
 * Render a ChargeOver invoice id as a clickable link when the admin URL
 * is configured, otherwise plain text. Lets every "show an invoice id"
 * surface use one component so re-pointing at a sandbox CO instance (or
 * temporarily disabling links) is a single env-var change.
 *
 * `display` overrides the link text — useful when the column shows
 * "Invoice #1234" but the data row holds the numeric id (or vice versa).
 */
export function InvoiceLink({
  invoiceId,
  display,
  style,
}: {
  invoiceId: string | number | null | undefined;
  display?: string | null;
  style?: React.CSSProperties;
}) {
  const { config } = useConfig();
  const text = display ?? (invoiceId != null ? String(invoiceId) : '—');
  if (invoiceId == null) {
    return <span style={style}>—</span>;
  }
  const url = chargeoverInvoiceUrl(config, invoiceId);
  if (!url) {
    return <span style={style}>{text}</span>;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'var(--color-blue)', textDecoration: 'underline', ...style }}
      onClick={(e) => e.stopPropagation()}
    >
      {text} ↗
    </a>
  );
}
